<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col cols="12" lg="4">
        <div class="form-group">
          <label
            for="documenttype_title"
            class="form-control-label">{{$t('views.documenttype.form.title')}}:</label>
          <input
            id="title"
            v-model="item.title"
            :class="['form-control', isInvalid('title') ? 'is-invalid' : '']"
            type="text"
            placeholder=""
            @input="handleUpdateField('title', $event.target.value)">
          <div
            v-if="isInvalid('title')"
            class="invalid-feedback">{{ violations.title }}</div>
        </div>
      </b-col>
      <b-col cols="12" lg="4">
        <div class="form-group">
          <label
            for="documenttype_subtitle"
            class="form-control-label">{{$t('views.documenttype.form.subtitle')}}:</label>
          <input
            id="subtitle"
            v-model="item.subtitle"
            :class="['form-control', isInvalid('subtitle') ? 'is-invalid' : '']"
            type="text"
            placeholder=""
            @input="handleUpdateField('subtitle', $event.target.value)">
          <div
            v-if="isInvalid('subtitle')"
            class="invalid-feedback">{{ violations.subtitle }}</div>
        </div>
      </b-col>
      <b-col cols="12" lg="4">
        <div class="form-group">
          <label
            for="documenttype_language"
            class="form-control-label">{{$t('views.documenttype.form.language')}}:</label>
          <input
            id="documenttype_language"
            v-model="item.language"
            :class="['form-control', isInvalid('language') ? 'is-invalid' : '']"
            type="text"
            placeholder=""
            @input="handleUpdateField('language', $event.target.value)">
          <div
            v-if="isInvalid('language')"
            class="invalid-feedback">{{ violations.language }}</div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" lg="4">
        <div class="form-group">
          <label
            for="documenttype_version"
            class="form-control-label">{{$t('views.documenttype.form.version')}}:</label>
          <input
            id="documenttype_version"
            v-model="item.version"
            :class="['form-control', isInvalid('version') ? 'is-invalid' : '']"
            type="number"
            placeholder=""
            min="1"
            @input="handleUpdateField('version', $event.target.value)">
          <div
            v-if="isInvalid('version')"
            class="invalid-feedback">{{ violations.version }}</div>
        </div>
      </b-col>
      <b-col cols="12" lg="4">
        <div class="form-group">
          <label
            for="documenttype_specialInfo"
            class="form-control-label">{{$t('views.documenttype.form.specialInfo')}}:</label>
          <input
            id="specialInfo"
            v-model="item.specialInfo"
            :class="['form-control', isInvalid('specialInfo') ? 'is-invalid' : '']"
            type="text"
            placeholder=""
            @input="handleUpdateField('specialInfo', $event.target.value)">
          <div
            v-if="isInvalid('specialInfo')"
            class="invalid-feedback">{{ violations.specialInfo }}</div>
        </div>
      </b-col>
      <b-col cols="12" lg="4">
        <div class="form-group">
          <label
            for="documenttype_allowedExtensions"
            class="form-control-label">{{$t('views.exsbdocument.form.allowedExtensionsForm')}}:</label>
          <input
            id="documenttype_allowedExtensions"
            v-model="item.allowedExtensions"
            :class="['form-control', isInvalid('allowedExtensions') ? 'is-invalid' : '']"
            type="text"
            placeholder=""
            @input="handleUpdateField('allowedExtensions', $event.target.value)">
          <div
            v-if="isInvalid('allowedExtensions')"
            class="invalid-feedback">{{ violations.allowedExtensions }}</div>
        </div>
      </b-col>
      <b-col cols="12" lg="4">
        <div class="form-group">
          <label
            for="documenttype_caseTypesAllowed"
            class="form-control-label">{{$t('views.documenttype.form.caseTypesAllowed')}}:</label>
          <b-form-group>
            <b-form-checkbox-group
              v-model="item.caseTypesAllowed"
              :options="caseTypes"
              name="documenttype_caseTypesAllowed"
            ></b-form-checkbox-group>
          </b-form-group>
          <div
            v-if="isInvalid('caseTypesAllowed')"
            class="invalid-feedback">{{ violations.caseTypesAllowed }}</div>
        </div>
      </b-col>
      <b-col cols="6">
        <label>{{$t('views.documenttype.form.accessType')}}: </label>
        <div>
          <b-form-radio-group buttons button-variant="outline-primary" id="requirePromotion" v-model="item.accessType">
            <b-form-radio button-variant="outline-primary" :value="0">{{$t('views.documenttype.form.accessTypeOptions.all')}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="1">{{$t('views.documenttype.form.accessTypeOptions.byRoles')}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="2">{{$t('views.documenttype.form.accessTypeOptions.self')}}</b-form-radio>
          </b-form-radio-group>
        </div>
      </b-col>
      <b-col cols="6" v-if="item.accessType === 1">
        <div class="form-group">
          <label
            for="documenttype_caseTypesAllowed"
            class="form-control-label">{{$t('views.documenttype.form.rolesToViewAllowed')}}:</label>
          <b-form-group>
            <b-form-checkbox-group
              v-model="item.rolesToViewAllowed"
              :options="clientTypeOptions"
              name="documenttype_rolesToViewAllowed"
            ></b-form-checkbox-group>
          </b-form-group>
          <div
            v-if="isInvalid('rolesToViewAllowed')"
            class="invalid-feedback">{{ violations.rolesToViewAllowed }}</div>
        </div>
      </b-col>
    </b-row>
    <button
      type="submit"
      class="btn btn-success">{{ $t('buttons.submit') }}</button>
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import getId from '@/utils/getIdFromLink'
import ApiService from '@/utils/ApiService'

export default {
  created () {
    this.getCaseType()
    this.getClientTypes()
  },
  data () {
    return {
      clientTypeOptions: []
    }
  },
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    },
    caseTypes () {
      return this.casetype.map(entry => {
        return {
          value: getId(entry['@id']),
          text: entry.title
        }
      })
    },
    ...mapGetters({
      casetype: 'excmcasetype/list/items'
    })
  },

  methods: {
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },
    async getClientTypes () {
      let params = { pagination: false }
      const response = await new ApiService('client_types', params).getResults()
      this.clientTypeOptions = response.items.map(entry => {
        return {
          value: getId(entry['@id']),
          text: entry.title
        }
      })
    },
    ...mapActions({
      getCaseType: 'excmcasetype/list/default'
    })
  }
}
</script>
